import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "./commonSlice";
import commonService from "../common/commonService";
import { API_URLS, STATUS_CODES } from "../common/constants";
import { toast } from "react-toastify";

const initialState = {
  errorMessage: "",
  error: null,
  isReportDownloaded: false,
  questionnaireData: [],
};

export const questionnaireReportData = createAsyncThunk(
  "questionnaire/details",
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    const res = await commonService.postRequest(
      API_URLS.QUESTIONNAIRE_DATA +
        `?${commonService.getQueryFromObject(data?.pageData)}`,
      data?.employeeData
    );
    dispatch(stopLoading());
    if (res.statusCode !== STATUS_CODES.SUCCESS) {
      toast.error(res.message);
      return rejectWithValue(res.message);
    }
    return res;
  }
);

export const downloadQuestionnaireReport = createAsyncThunk(
  "questionnaire/report",
  async (data, {rejectWithValue, dispatch}) => {
    dispatch(startLoading())
    const res = await commonService.postRequest(
      API_URLS.QUESTIONNAIRE_REPORT, 
      data
    );
    dispatch(stopLoading());
    if(res.statusCode !== STATUS_CODES.SUCCESS){
      toast.error(res.message);
      return rejectWithValue(res.message);
    }
    toast.success(res.message)
      return res;
    
  }
)

const questionnaireReportSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    reset: (state) => {
      return {
        ...state,
        error: null,
        isReportDownloaded: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(questionnaireReportData.pending, (state) => {
        return {
          ...state,
          error: null,
          questionnaireData: [],
        };
      })
      .addCase(questionnaireReportData.fulfilled, (state, action) => {
        return {
          ...state,
          error: false,
          questionnaireData: action.payload.data,
          totalRows: action.payload.totalDocs,
        };
      })
      .addCase(questionnaireReportData.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
          questionnaireData: [],
        };
      });
  },
});

export const {reset} = questionnaireReportSlice.actions
const {reducer} = questionnaireReportSlice
export default reducer
